module.exports = __webpack_public_path__ + "static/media/avatar-f.53e051cd.png";